import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { selectCurrentUser } from '../../features/Auth/authSlice';

const Protected = ({ layout = 'home', children }) => {
  const user = useSelector(selectCurrentUser);
  return user?.layout === layout ? children : <Navigate to={`/${user?.layout}`} />;
};

export default Protected;
